export default __webpack_public_path__ + "static/media/what-we-provide-codebase-icon.288ad569.svg";